import Immutable from 'immutable';

export const State = Immutable.fromJS({
	product: {},
	buyQuantity: 1
});
